import { faAt, faLocationDot, faPhoneVolume } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ContactSection = () => {
    return (
        <div id="contact">
            <div className="relative mt-20">
                <div className="text-center">
                    <h2 className="text-3xl sm:text-5xl lg:text-6xl mt-10 lg:mt-20 tracking-wide">
                        Contact{" "}
                        <span className="bg-gradient-to-r from-cyan-500 to-cyan-600 text-transparent bg-clip-text">
                            Us
                        </span>
                    </h2>
                </div>
                <div className="max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:py-20 lg:px-8">
                    <div className="grid sm:grid-cols-1 lg:grid-cols-3 gap-12 mb-12">
                        <div className="flex flex-col items-center py-4">
                            <FontAwesomeIcon className='text-cyan-500 text-4xl' icon={faLocationDot} />
                            <div className="mt-4 text-center">
                                <h4 className="text-gray-800 text-base font-bold">Address</h4>
                                <p className="text-sm text-gray-500 mt-2 text-left">30 N Gould St Ste R Sheridan, WY 82801</p>
                            </div>
                        </div>

                        <div className="flex flex-col items-center py-4">
                            <FontAwesomeIcon className='text-cyan-500 text-4xl' icon={faPhoneVolume} />
                            <div className="mt-4 text-center">
                                <h4 className="text-gray-800 text-base font-bold">Call us</h4>
                                <p className="text-sm text-gray-500 mt-2">+1 213-279-5633</p>

                            </div>
                        </div>

                        <div className="flex flex-col items-center py-4">
                            <FontAwesomeIcon className='text-cyan-500 text-4xl' icon={faAt} />
                            <div className="mt-4 text-center">
                                <h4 className="text-gray-800 text-base font-bold">Email</h4>
                                <p className="text-sm text-gray-500 mt-2">salepersona66@gmail.com</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContactSection;
